import { createSlice } from '@reduxjs/toolkit';
import { OrganisationState } from './types';
import { TIME_RANGE } from '../../constants';

const initialState: OrganisationState = {
  organisationDetails: {
    loading: false,
    error: null,
    data: null,
    selectedRange: 'All'
  },
  organisationActivity: {
    loading: false,
    error: null as string | null,
    data: null,
    selectedRange: TIME_RANGE.WEEKLY
  },
  organisationDashboardActivity: {
    loading: false,
    error: null,
    data: null,
    selectedRange: TIME_RANGE.WEEKLY
  },
  organisationDashboardLineActivity: {
    loading: false,
    error: null,
    data: null,
    selectedRange: TIME_RANGE.WEEKLY
  }
};

const organisationSlice = createSlice({
  name: 'organisationSlice',
  initialState,
  reducers: {
    setOrganisationDetailsRange: (state, action) => {
      state.organisationDetails.selectedRange = action.payload;
    },
    setOrganisationAcitivityRange: (state, action) => {
      state.organisationActivity.selectedRange = action.payload;
    },
    setOrganisationDashboardAcitivityRange: (state, action) => {
      state.organisationDashboardActivity.selectedRange = action.payload;
    },
    setOrganisationDashboardLineActivityRange: (state, action) => {
      state.organisationDashboardLineActivity.selectedRange = action.payload;
    }
  }
});

export const {
  setOrganisationDetailsRange,
  setOrganisationAcitivityRange,
  setOrganisationDashboardAcitivityRange,
  setOrganisationDashboardLineActivityRange
} = organisationSlice.actions;
export default organisationSlice.reducer;
